import {
  UPLOAD_EXCEL_TRIMBLE,
  UPLOAD_EXCEL_TRIMBLE_ERROR,
  UPLOAD_EXCEL_TRIMBLE_SUCCESS,
  FETCH_FOLDERS,
  FETCH_FOLDERS_ERROR,
  FETCH_FOLDERS_SUCCESS,
  FETCH_SUB_FOLDERS,
  FETCH_SUB_FOLDERS_ERROR,
  FETCH_SUB_FOLDERS_SUCCESS,
  GET_TRIMBLE_DATA,
  GET_TRIMBLE_DATA_ERROR,
  GET_TRIMBLE_DATA_SUCCESS,
} from './Trimble.actions';

const initialState = {
  loading: false,
  error: undefined,
  fileKey: null,
  loadingFolder: true,
  errorFolder: undefined,
  folders: [],
  loadingSubFolder: true,
  errorSubFolder: undefined,
  subFolders: [],
  loadingTrimbleData: true,
  errorTrimbleData: undefined,
  trimbleData: [],
};

/**
 * Reducer for Trimble file upload and metadata fetching.
 */
const trimbleUploadReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case UPLOAD_EXCEL_TRIMBLE: {
      return { ...state, loading: true, error: undefined, fileKey: null }; // Start loading, reset error and fileKey
    }
    case UPLOAD_EXCEL_TRIMBLE_ERROR: {
      return { ...state, loading: false, error: payload.error }; // Stop loading, store error
    }
    case UPLOAD_EXCEL_TRIMBLE_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: undefined,
        fileKey: payload.key, // Save the uploaded file key
      };
    }

    // Fetching folders
    case FETCH_FOLDERS:
      return { ...state, loadingFolder: true, errorFolder: null };
    case FETCH_FOLDERS_SUCCESS:
      return {
        ...state,
        loadingFolder: false,
        errorFolder: undefined,
        folders: payload.folders,
      };
    case FETCH_FOLDERS_ERROR:
      return { ...state, loadingFolder: false, errorFolder: payload.error };

    // Fetching subfolders
    case FETCH_SUB_FOLDERS:
      return { ...state, loadingSubFolder: true, errorSubFolder: null };
    case FETCH_SUB_FOLDERS_SUCCESS:
      return {
        ...state,
        loadingSubFolder: false,
        errorSubFolder: undefined,
        subFolders: payload.folders,
      };
    case FETCH_SUB_FOLDERS_ERROR:
      return {
        ...state,
        loadingSubFolder: false,
        errorSubFolder: payload.error,
      };

    // Fetching Trimble data
    case GET_TRIMBLE_DATA:
      return { ...state, loadingTrimbleData: true, errorTrimbleData: null };
    case GET_TRIMBLE_DATA_SUCCESS:
      return {
        ...state,
        loadingTrimbleData: false,
        errorTrimbleData: undefined,
        trimbleData: payload.data, // Store fetched Trimble data
      };
    case GET_TRIMBLE_DATA_ERROR:
      return {
        ...state,
        loadingTrimbleData: false,
        errorTrimbleData: payload.error,
      };

    default:
      return state; // Return unchanged state
  }
};

export default trimbleUploadReducer;
